import React, { useState, useEffect } from 'react';
import AdminLogin from './AdminLogin';
import AdminOrderList from './AdminOrderList';
import AdminOrderForm from './AdminOrderForm';
import AdminOrderDetail from './AdminOrderDetail';

export default function AdminDashboard() {
  const [page, setPage] = useState('list'); // 'list' | 'form' | 'detail'
  const [editId, setEditId] = useState(null);
  const [detailId, setDetailId] = useState(null);
  const [isAdmin, setIsAdmin] = useState(!!localStorage.getItem('adminToken'));
  const [currentUser, setCurrentUser] = useState(null);
  const [tokenValid, setTokenValid] = useState(true); // 添加token有效性状态

  // 验证token是否有效
  const validateToken = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      if (!token) {
        setTokenValid(false);
        return false;
      }

      const response = await fetch(`/api/adminAuth/checkToken`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        // token无效，清除本地存储并重新登录
        localStorage.removeItem('adminToken');
        setIsAdmin(false);
        setCurrentUser(null);
        setTokenValid(false);
        return false;
      }

      setTokenValid(true);
      return true;
    } catch (error) {
      console.error('Token验证失败:', error);
      localStorage.removeItem('adminToken');
      setIsAdmin(false);
      setCurrentUser(null);
      setTokenValid(false);
      return false;
    }
  };

  // 获取当前用户信息
  const fetchCurrentUser = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      if (!token) return;

      const response = await fetch(`/api/admin/currentUser`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const userData = await response.json();
        setCurrentUser(userData);
      } else if (response.status === 401) {
        // token过期，清除本地存储
        localStorage.removeItem('adminToken');
        setIsAdmin(false);
        setCurrentUser(null);
        setTokenValid(false);
      }
    } catch (error) {
      console.error('获取用户信息失败:', error);
      // 网络错误时也清除token
      localStorage.removeItem('adminToken');
      setIsAdmin(false);
      setCurrentUser(null);
      setTokenValid(false);
    }
  };

  // 组件加载时验证token
  useEffect(() => {
    if (isAdmin) {
      validateToken().then(isValid => {
        if (isValid) {
          fetchCurrentUser();
        }
      });
    }
  }, [isAdmin]);

  // 退出登录
  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    setIsAdmin(false);
    setCurrentUser(null);
    setTokenValid(true);
    setPage('list');
    setEditId(null);
    setDetailId(null);
  };

  // 登录态处理
  if (!isAdmin || !tokenValid) {
    return <AdminLogin onLogin={() => {
      setIsAdmin(true);
      setTokenValid(true);
    }} />;
  }

  // 用户信息显示组件
  const UserInfo = () => (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 16,
      padding: '12px 16px',
      backgroundColor: '#f8f9fa',
      borderRadius: '8px',
      border: '1px solid #e9ecef'
    }}>
      <div style={{ fontSize: '14px', color: '#6c757d' }}>
        {currentUser ? (
          <>
            当前用户: <strong style={{ color: '#495057' }}>{currentUser.username}</strong>
            <span style={{ marginLeft: 8, color: '#6c757d' }}>
              ({currentUser.roleDisplay})
            </span>
          </>
        ) : (
          '正在加载用户信息...'
        )}
      </div>
      <button 
        onClick={handleLogout}
        style={{
          padding: '6px 12px',
          backgroundColor: '#dc3545',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '12px'
        }}
      >
        退出登录
      </button>
    </div>
  );

  // 订单录入/编辑页
  if (page === 'form') {
    return (
      <main style={{maxWidth: 900, margin: '32px auto', width: '100%'}}>
        <div className="card">
          <UserInfo />
          <AdminOrderForm
            id={editId}
            onBack={() => {
              setPage('list');
              setEditId(null);
            }}
            onSaved={(newId) => {
              setDetailId(newId);
              setPage('detail');
            }}
          />
        </div>
      </main>
    );
  }

  // 订单详情页
  if (page === 'detail') {
    return (
      <main style={{maxWidth: 900, margin: '32px auto', width: '100%'}}>
        <div className="card">
          <UserInfo />
          <AdminOrderDetail
            id={detailId}
            onBack={() => {
              setPage('list');
              setDetailId(null);
            }}
            onEdit={id => {
              setEditId(id);
              setPage('form');
            }}
          />
        </div>
      </main>
    );
  }

  // 订单列表页
  return (
    <main style={{maxWidth: 900, margin: '32px auto', width: '100%'}}>
      <div className="card">
        <UserInfo />
        <AdminOrderList
          onEdit={id => {
            setEditId(id);
            setPage('form');
          }}
          onDetail={id => {
            setDetailId(id);
            setPage('detail');
          }}
        />
      </div>
    </main>
  );
}